import _api from "./api";
import _endpoints from "./endpoints";

export default {
    async getPopups() {
        const {data} = await _api.get(_endpoints.get_popups);
        return data;
    },
}